<template>
    <div class="home" :style="{ minHeight: bodyHeight + 'px' }">
        <gTop />
        <gHead />
        <gNav />
        <div class="gContent" v-if="proData" :style="{ minHeight: (bodyHeight - 256) + 'px' }">
            <!-- 产品信息 -->
            <div class="m-info">
                <div class="m-info-title">
                    <h3 :title="proData.nameEn" v-if="proData.nameEn">{{ proData.nameEn }}</h3>
                    <h3 :title="proData.name" v-else>{{ proData.name }}</h3>
                    <!-- 产品标签 -->
                    <span v-if="tag">{{ tag }}</span>
                    <p>
                        <Button type="info" ghost style="width:70px;height:35px;font-size:14px;" :disabled="hasCollect"
                            @click="addCollect">Follow</Button>
                        <Button type="error" ghost style="width:200px;height:35px;font-size:14px;margin-left:20px;"
                            @click="supply()">Seek business cooperation</Button>
                    </p>
                </div>
                <!-- <div class="m-info-brand">
          <div class="brand">
            <i class="icon iconfont icon-tubiao-"></i>
            <span>{{proData.applyCount}}</span>
          </div>
          <div class="brand">
            <i class="icon iconfont icon-share"></i>
            <span>{{proData.shareCount}}</span>
          </div>
          <div class="brand">
            <i class="icon iconfont icon-liuyan4"></i>
            <span>{{proData.commentCount}}</span>
          </div>
          <div class="brand">
            <i class="icon iconfont icon-chakan"></i>
            <span>{{proData.viewCount}}</span>
          </div>
        </div> -->
                <!-- 产品类别 -->
                <div class="m-info-line" v-if="category">
                    <i class="icon iconfont icon-biaoqian1" style="color: #329baa;"></i>
                    <span style="padding-left: 0px;">{{ category }}</span>
                </div>
                <!-- 各项认证 -->
                <div class="m-info-certificate">
                    <template v-if="proData.authentication && proData.authentication.length > 0">
                        <span class="c" v-for="(auth, authIdx) in proData.authentication" :key="'auth' + authIdx">{{
                            auth.Name }}</span>
                    </template>
                    <template v-if="proData.certificateQualities && proData.certificateQualities.length > 0">
                        <span class="q" v-for="(authQualities, authQualitiesIdx) in proData.certificateQualities"
                            :key="'authQualities' + authQualitiesIdx">{{ authQualities.Name }}</span>
                    </template>
                </div>
                <!-- 招商区域 -->
                <div class="m-info-region" v-if="proData.zhaoShangRegion && proData.zhaoShangRegion.length > 0">
                    <span style="display:inline-block;width:85px;line-height:25px;">Service Area</span>
                    <div v-if="(proData.zhaoShangRegion[0] instanceof Array)">
                        <span v-for="(zs, zx) in proData.zhaoShangRegion" v-if="zs.length" :key="zx">
                            <template v-if="zs.length === 1">
                                {{ zs[0] }}
                            </template>
                            <template v-if="zs.length === 2">
                                {{ zs[0] + "/" + zs[1] }}
                            </template>
                            <template v-if="zs.length === 3">
                                {{ zs[0] + "/" + zs[1] + "/" + zs[2] }}
                            </template>
                        </span>
                    </div>
                    <div v-else>
                        <span>{{ proData.zhaoShangRegion[0] + "/" + proData.zhaoShangRegion[1] + "/" +
                            proData.zhaoShangRegion[2] }}</span>
                    </div>
                </div>
            </div>
            <!-- 产品内容 -->

            <div class="main">
                <div class="section">
                    <div style="padding:20px 20px 0;" v-if="proData && proData.intro">
                        Product Introduction：<p v-html="proData.introductionEn" v-if="proData.introductionEn"></p>
                        <p v-html="proData.intro" v-else></p>
                    </div>
                    <div class="section-top">
                        <div class="m-swiper" v-if="imgArr" style="margin-bottom:20px;">
                            <!-- 轮播的banner和视频 -->
                            <gSwiperCommon3 :list="imgArr"></gSwiperCommon3>
                        </div>
                        <!-- 产品介绍 -->
                        <div class="m-content">
                            <div v-for="(item, index) in proData.introduction" :key="index">
                                <!-- 文字 -->
                                <p class="int-text" v-if="item.text" style="padding:10px 0;"
                                    :style="{ 'font-size': item.text.fontSize, 'color': item.text.color, 'text-align': item.text.position }"
                                    v-html="item.text.content ? $service.replaceSpeace(item.text.content) : '暂无介绍'">
                                </p>
                                <!-- 图片 -->
                                <div class="int-img" style="font-size:0;" v-if="item.picture && item.picture.type == 1"
                                    :style="{ 'padding-left': item.picture.padding + 'px', 'padding-right': item.picture.padding + 'px' }">
                                    <div v-for="(itm, idx) in item.picture.list" :key="idx"
                                        :style="{ 'margin-bottom': item.picture.spacing + 'px' }">
                                        <img :src="itm.url" style="width:100%;" @click="imgLink(itm.link)">
                                    </div>
                                </div>
                                <!-- 轮播图片 -->
                                <div class="m-swiper" v-if="item.picture && item.picture.type == 2">
                                    <gSwiperCommon2 v-if="comInfo" :comInfo="comInfo" :list="item.picture.list">
                                    </gSwiperCommon2>
                                </div>
                                <!-- 视频 -->
                                <div class="int-video" v-if="item.video">
                                    <video style="width:100%;height:100%;object-fit:fill;" :src="item.video.link"
                                        :poster="item.video.cover ? item.video.cover : ''" controls="controls">
                                        您的浏览器不支持video标签
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="section-bot">
            <leavingmessage @showLogin="show=true;" :typeId="proId" :type="'pro'" v-if="proId"></leavingmessage>
          </div> -->
                </div>

                <div class="sidebar" v-if="comInfo">
                    <sidebarqrcode :url="url" :companyMsg="comInfo" :showCom="true"></sidebarqrcode>
                </div>
            </div>
        </div>
        <supplyModal :show="supplyOpen" @close="supplyOpen = false" :infoData="proData" :infoType="'展品'" />
        <gInfo />
        <gBottom />
        <gLogin :show="show" @close="show = false;" />


        <!-- <div v-if="isPop" >
        <div  class="popLayer  " style="display: block"></div>
        <div  style="text-align: center;display: block" class="popup_first">
            <img
        class="logo"
        style="
          width: 300px;
          display: block;
          border-radius: 15px;
          height: 400px;
          position: absolute;
          left: 50%;
          top: 20%;
          margin-left: -150px;
          margin-top: -150px;
          z-index: 999;
        "
        mode="widthFix"
        src="https://oss.cmef.com.cn/cloudExhibition/imgs/202309/a37b5da1bcf948a4b720992728e28d75.png"
      />
            <p @click="closeSearch()" class="closeB">
            <img  src="https://oss.cmef.com.cn/cloudExhibition/imgs/202303/5c3b8b59dc974f288ecdcf194d3bae00.png" alt="" style="  width: 50px;height: 100px;">
            </p>
        </div>
    </div> -->

    <div v-if="isPop"  @touchmove.prevent>
    <!-- <van-popup :show="show" bind:close="onClose" z-index="130" close-on-click-overlay close-icon-position="top-right" @close="onClose" round >
      <div class="form" style="background: #221790;" >
        <i class="icon iconfont icon-guanbi" style="position: absolute; right: 0;color: #000000;" @click="onClose"></i>
        <image class="logo" @click="goLink(list)" style="display: block;" mode="widthFix" :src="list.pictureUrl" v-if="list && list.pictureUrl" />  
      </div>
    </van-popup> -->
    <!-- <div @click="onClose" style="color: #fff;background: rgba(0, 0, 0, .7);" class="disCen"><img style="width: 60px;height: 60px;" src="../../../assets/img/navBack/X.png" alt=""></div> -->

    <div class="popLayer" style="display: block"></div>
    <div style="text-align: center; display: block" class="popup_first">
      <img
        class="logo"
        style="
          width: 300px;
          display: block;
          border-radius: 15px;
          height: 400px;
          position: absolute;
          left: 50%;
          top: 20%;
          margin-left: -150px;
          margin-top: -150px;
          z-index: 999;
        "
        mode="widthFix"
        src="https://oss.cmef.com.cn/cloudExhibition/imgs/202309/a37b5da1bcf948a4b720992728e28d75.png"
      />
      <p @click="closeSearch()" class="closeB">
        <img
          src="https://oss.cmef.com.cn/cloudExhibition/imgs/202303/5c3b8b59dc974f288ecdcf194d3bae00.png"
          alt=""
          style="width: 50px; height: 100px"
        />
      </p>
    </div>
  </div>
    </div>
</template>

<script>
import gLogin from "@components/En/gLogin/gLogin.vue";
import gTop from "@components/En/gTop/gTop.vue";
import gHead from "@components/En/gHead/gHead.vue";
import gNav from "@components/En/gNav/gNav.vue";
import gBottom from "@components/En/gBottom/gBottom.vue";
import gSwiperCommon3 from "@components/En/gSwiperCommon3/gSwiperCommon3.vue"; //轮播图
import gSwiperCommon2 from "@components/En/gSwiperCommon2/gSwiperCommon2.vue"; //轮播图
import leavingmessage from "@components/En/leaving-message"; //留言
import sidebarqrcode from "@components/En/sidebar-QRcode"; //边栏 扫描二维码
import supplyModal from "@components/En/modal/supply-modal"; //供需modal
import gInfo from "@components/En/gInfo/gInfo.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    name: "pro-details",
    data () {
        return {
            bodyHeight: "800px",
            proId: "",
            proData: null,
            compId: "",
            tag: "", // 产品标签
            category: "",
            zhaoShangRegion: "", // 服务地区
            comInfo: null,
            imgArr: null,
            supplyOpen: false,
            url: "",
            hasCollect: false,
            show: false,
            isPop: false,
        };
    },
    watch: {
        '$route' (to, from) {
            if (to) {
                this.$nextTick(
                    this.imgArr = null
                );
                this.init();
            }
        },
        user (val, oldVal) {
            this.isCollect();
        },
        proCollectId (val, oldVal) {
            this.isCollect();
        }
    },
    components: {
        gTop,
        gHead,
        gNav,
        gBottom,
        gSwiperCommon2,
        gSwiperCommon3,
        leavingmessage,
        sidebarqrcode,
        supplyModal,
        gInfo,
        gLogin
    },
    created () {
        this.init();
        this.isPop=this.$route.query.isPop
        if(this.isPop){
            this.stopMove()
        }
    },
    computed: {
        ...mapGetters({
            user: "getUser",
            exhibitionId: "getExhibitionId",
            proCollectId: "getProCollectId"
        }),
        SystemConfig () {
            return this.$store.state.SystemConfig;
        },
        showPop () {
            return this.$store.state.showPop;
        },
      
    },
    methods: {
        ...mapMutations({
            setProCollectId: "setProCollectId"
        }),
        ...mapActions({
            getUser: "hall/getUser",
            getWeAppCode: "exhibitionModule/getWeAppCode",
            isProCollect: "hall/isProCollect"
        }),
        closeSearch(){
    this.isPop = false;
    this.Move()
    },

    //停止页面滚动 
stopMove(){
    let m = function(e){e.preventDefault();}; 
	document.body.style.overflow='hidden';
	document.addEventListener('touchmove',m,{ passive:false });//禁止页面滑动 
}, 
 //开启页面滚动 
 Move(){ 
 	let m =function(e){e.preventDefault();}; 
 	document.body.style.overflow='';
 	//出现滚动条
  	document.removeEventListener('touchmove',m,{ passive:true }); 
},



        async init () {
            this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
            this.proId = this.$router.history.current.params.id;
            this.compId = this.$router.history.current.query.compId;
            this.productData(); // 获取产品
            this.getCom(); // 获取对应公司
            this.getCode();
            this.isCollect();
        },
        productData () {
            // 获取产品
            this.$http.get("api/product?id=" + this.proId, this.$store.state.header).then(res => {
                if (res.status === 200 && res.data) {
                    if (res.data.banner) {
                        res.data.banner = JSON.parse(res.data.banner);
                    }
                    if (res.data.video) {
                        res.data.video = JSON.parse(res.data.video);
                    }
                    if (res.data.tag) {
                        res.data.tag = JSON.parse(res.data.tag);
                        if (res.data.tag.List && res.data.tag.List.length > 0) {
                            let tag = "";
                            res.data.tag.List.map(c => {
                                tag += "/" + c.Value;
                            })
                            this.tag = res.data.tag.Value + tag;
                        } else {
                            this.tag = res.data.tag.Value;
                        }
                    }
                    if (res.data.authentication) {
                        res.data.authentication = JSON.parse(res.data.authentication);
                    }
                    if (res.data.certificateQualities) {
                        res.data.certificateQualities = JSON.parse(res.data.certificateQualities);
                    }
                    if (res.data.category) {
                        let category = JSON.parse(res.data.category);
                        if (category.List && category.List.length > 0) {
                            this.category = category.Value + ' > ' + category.List[0].Value;
                        } else {
                            this.category = category.Value;
                        }
                    }
                    if (res.data.zhaoShangRegion) {
                        res.data.zhaoShangRegion = JSON.parse(res.data.zhaoShangRegion);
                    }
                    if (res.data.introduction) {
                        res.data.introduction = JSON.parse(res.data.introduction);
                    }
                    let imgArr = {
                        img: [],
                        video: {}
                    };
                    imgArr.img = res.data.banner;
                    imgArr.video = res.data.video;
                    this.imgArr = imgArr;
                    this.proData = res.data;
                    if (this.proData && this.proData.intro) {
                        this.proData.intro = this.proData.intro.replace(/\n/g, "<br/>");
                    }
                    // console.log("proData:",this.proData);
                }
            });
        },
        getCom () {
            this.$http.get("api/Join/DefaultJoin?compId=" + this.compId, this.$store.state.header).then(res => {
                if (res.status === 200 && res.data) {
                    this.comInfo = res.data;
                }
            });
        },
        imgLink (e) {
            switch (e.type) {
                case "0": // 自定义
                    window.location.href = e.value;
                    break;
                case "1": // 公司
                    this.$router.push(`/ex-detailsEn/${this.comInfo.joinId}?exhibitionId=${this.exhibitionId}&compId=${this.compId}`);
                    break;
                case "3": // 产品
                    this.$router.push(`/pro-detailsEn/${e.value}?compId=${this.compId}`);
                    break;
                case "5": // 动态
                    this.$router.push(`/chanceEn`);
                    break;
            }
        },
        async getCode () {
            let opt = {
                targetType: 1,
                targetId: this.proId,
                scene: this.proId
            }
            let data = await this.getWeAppCode(opt);
            if (data) {
                this.url = data.path;
            }
        },
        async isCollect () {
            this.setProCollectId("");
            if (!this.user) {
                return;
            }
            let isCollect = await this.isProCollect({
                userId: this.user.userId,
                productId: this.proId
            });
            this.hasCollect = isCollect;
        },
        supply () {
            if (!this.user) {
                this.show = true;
                this.$Message.warning("请登录后发布");
                return;
            }
            this.supplyOpen = true;
        },
        async addCollect () {
            if (!this.user) {
                this.show = true;
                this.$Message.warning("请登录后关注");
                return;
            }
            this.$http.get(`/api/ProductFollow/follow?userId=${this.user.userId}&productId=${this.proId}`, this.$store.state.header)
                .then(res => {
                    if (res.status === 200 && res.data.successed) {
                        this.$Message.success("success！");
                        this.isCollect();
                        this.countTag();

                    } else {
                        this.$Message.error("fail,please try again！");
                    }
                })
        },


        async countTag () {
            if (this.$route.query.typeName) {
                let opt = {
                    tagId: this.$route.query.typeName == 1 ? 'fcb459d0-9565-413b-832d-f25bba4c3567' : '45866a37-7712-4177-8f77-0183d1357578',
                    dataType: "product",
                    pageType: "pcen",
                    countType: "follow",
                    productId: this.proId,
                    categoryId: null,
                    userId: null,
                    ips: sessionStorage.getItem('ip')?sessionStorage.getItem('ip'):'127.0.0.1'
                }
                let comments = await this.$service.postTagCount(this, opt)
            }
        },
    }
};
</script> 

<style scoped lang='scss'>
@import "@assets/scss/utils.scss";


.popLayer {
  height: 700%;
  background-color: #000;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  -moz-opacity: 0.4;
  opacity: 0.4;
  filter: alpha(opacity=80);
  /* 只支持IE6、7、8、9 */
}

.title {
  z-index: 9999;
  position: absolute;
  color: #d9b97e;
  top: -40px;
  text-align: center;
  width: 50%;
  font-size: 20px;
  left: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.productName {
  z-index: 9999;
  position: absolute;
  color: #ffffff;
  top: 225px;
  text-align: center;
  width: 50%;
  font-size: 16px;
  left: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.productBanner {
  z-index: 9999;
  position: relative;
  width: 190px;
  height: 150px;
  bottom: -60px;
  left: 10px;
}
.productBanner1 {
  z-index: 9999;
  position: relative;
  width: 190px;
  height: 150px;
  bottom: -60px;
  left: 10px;
}
.popup_first {
  // background-color: #FFFFFF;
  z-index: 9999999;

  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  width: 580px;
  height: 387px;
  // border-radius: 15px;
}
.showDisplay {
  display: block;
}
.unShowDisplay {
  display: none;
}

.closeB {
  bottom: 0;
  margin: auto;
  right: 0;
  position: absolute;
  left: 50%;
  top: 100%;
  margin-left: -295px;
  margin-top: -70px;
  z-index: 99;
}

.home {
    background: #f5f5f5;
}

.gContent {
    background: #f5f5f5;
    width: 1200px;
    margin: 20px auto 0;
}

.top-title {
    height: 50px;
    font-size: 14px;
    line-height: 35px;

    &-link {
        color: #999;
    }
}

.main {
    width: 1200px;
    margin-top: 20px;
    margin-bottom: 80px;
    @include clearfix;

    .section {
        width: 878px;
        border-radius: 2px;
        background-color: #fff;
        float: left;

        .section-top {
            padding: 50px 65px;
            box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
        }

        .title {
            min-height: 88px;
            border-bottom: 1px solid #f5f5f5;
        }

        .title div {
            width: 690px;
            margin-left: 94px;
        }

        .title h2 {
            font-size: 24px;
            color: #222222;
            margin-top: 28px;
        }

        .title span {
            font-size: 14px;
            color: #999;
            line-height: 1.5em;
            margin-top: 36px;
        }

        .info {
            margin: 14px 0 28px;

            span {
                margin: 0;

                &:first-child {
                    padding-left: 3px;
                }

                padding-left: 10px;
            }
        }

        .swiper .container {
            width: 690px;
            margin: 25px 0 0 94px;
        }

        .container2 {
            width: 690px;
            margin: 25px 0 0 94px;
        }

        .container2 p {
            font-size: 16px;
            color: #222222;
            line-height: 30px;
            margin-top: 40px;
            text-align: justify;
            word-break: break-all;
        }

        .fabulous {
            height: 130px;
            text-align: center;
            margin-top: 50px;
        }

        .fabulous div {
            display: inline-block;
            width: 220px;
            height: 77px;
            border-radius: 38px;
            border: solid 2px #e6e6e6;
            text-align: center;
            line-height: 77px;
            font-size: 20px;
            color: #222222;
            cursor: pointer;

            span {
                position: relative;
                top: -5px;
            }
        }

        .msg {
            margin-left: 94px;
        }

        .more {
            height: 80px;
            text-align: center;
        }

        .more span {
            color: #040000;
            font-size: 14px;
            cursor: pointer;
            line-height: 80px;
        }

        .icon {
            width: 1em;
            height: 1em;
            vertical-align: 0em;
            fill: currentColor;
            overflow: hidden;
            margin-right: 5px;
            font-size: 30px;
        }
    }

    .sidebar {
        width: 300px;
        float: right;
        // @include empty-txt(200px, "加载中...");
    }
}

.m-info {
    min-height: 160px;
    background-color: #fff;
    padding: 20px;
    margin-top: 28px;

    &-title {
        display: flex;
        align-items: center;
        // margin-bottom: 10px;
        position: relative;

        h3 {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            max-width: 560px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 20px;
        }

        span {
            font-size: 12px;
            font-weight: normal;
            line-height: 20px;
            color: #d13119;
            display: inline-block;
            padding: 0 6px;
            border-radius: 4px;
            background: rgba(209, 49, 25, .15);
            margin-right: 10px;
        }

        p {
            position: absolute;
            right: 0;
        }
    }

    &-brand {
        display: flex;
        align-items: center;

        // margin-bottom: 6px;
        .brand {
            align-items: center;
            display: flex;
            margin-right: 15px;
            color: #999;
            height: 32px;

            span {
                font-size: 16px;
            }

            i {
                font-size: 22px;
            }

            .icon-chakan {
                font-size: 24px;
            }
        }
    }

    &-line {
        width: calc(100% - 140px);
        margin-right: 10px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;

        i {
            font-size: 20px;
        }
    }

    &-region {
        width: calc(100% - 140px);
        margin-right: 10px;
        display: flex;

        div {
            span {
                display: inline-block;
                border-radius: 4px;
                background-color: #f5f5f5;
                margin-right: 10px;
                margin-bottom: 5px;
                padding: 2px 10px;
            }
        }
    }

    &-certificate {
        width: calc(100% - 140px);
        margin: 10px 10px 14px 0;

        span {
            margin-right: 10px;
            margin-bottom: 5px;
            border-radius: 4px;
            border: solid 1px #ff7a1f;
            padding: 2px 10px;
        }

        .c {
            color: #ff7a1f;
        }

        .q {
            color: #1890ff;
            border: solid 1px #1890ff;
        }
    }
}

.m-content {
    p {
        padding: 43px 0;
    }

    img {
        width: 100%;
    }
}

.section-bot {
    border-top: 20px solid #f5f5f5;
    width: 100%;
    background-color: #fff;
}

.int-video {
    width: 750px;
    height: 500px;
    // margin: 10px 0;
}
</style>
<style lang="scss">
.ivu-message {
    z-index: 1050 !important;
}



</style>